module.exports = __webpack_public_path__ + "media/images/icon_play-0a6b96e33bd5d3148724a8ddf0ae023a.png";